// Per-tier order-summary data shown beside the Stripe embedded form.
// Kept here (not in the catalog API) because it's purely presentational copy.

export const CHECKOUT_SUMMARY = {
  studio: {
    eyebrow: "ONE-TIME ACCESS",
    name: "Viral Book Studio",
    italic: "Studio",
    priceLabel: "one-time",
    features: [
      "Research viral book problems and generate concepts on demand",
      "Full manuscripts — outlines, chapters and scenes written end-to-end",
      "Amazon-ready descriptions, 7 SEO keywords and sub-categories",
      "Funnel-ready sales copy — emails, ads and product page blocks",
    ],
    guarantee: "14-day no-questions-asked refund",
  },
  suite: {
    eyebrow: "MOST POPULAR",
    name: "The Viral Book Suite",
    italic: "Suite",
    priceLabel: "one-time",
    features: [
      "Everything in Viral Book Studio",
      "Viral Book Cover Engine — 4 AI cover prompts in English, Spanish & French",
      "Viral Idea Evaluator — live financial scoring, hooks and angles",
      "Quick-start guide: the stacking workflow I use for every book",
    ],
    guarantee: "14-day no-questions-asked refund",
  },
  vip: {
    eyebrow: "VIP ACCESS",
    name: "Viral Book Suite VIP",
    italic: "VIP",
    priceLabel: "one-time",
    features: [
      "Everything in the Viral Book Suite",
      "PubGlot — AI translator for Spanish, French & German editions",
      "45-minute 1:1 onboarding call with me within 7 days",
      "Complete system video: my Evergreen Royalties engine end-to-end",
      "VA training video, publishing playbook, formatting system",
      "30 days of email support (48-hour response)",
    ],
    guarantee: "14-day guarantee + onboarding call refund promise",
  },
  cohort: {
    eyebrow: "HANDS-ON COACHING",
    name: "Evergreen Monthly Income Cohort",
    italic: "Cohort",
    priceLabel: "one-time",
    features: [
      "Everything in Viral Book Suite VIP",
      "6 monthly group calls with other action-takers",
      "Monthly 1:1 with me — catalogue review, sales analysis, next moves",
      "Every session recorded and delivered within 24 hours",
      "6 months of WhatsApp access directly to me",
      "Priority on every new Viral Book Suite tool at no extra cost",
    ],
    guarantee: "14-day guarantee — keep every recording you've watched",
  },
  dfy: {
    eyebrow: "DONE-FOR-YOU",
    name: "DFY Evergreen System",
    italic: "Installed",
    priceLabel: "one-time",
    features: [
      "Complete installation of my Evergreen Royalties system",
      "VA hired, trained and operating your suite on your behalf",
      "Every tool configured, tested and handed over running",
      "Priority Cohort seat + direct access for your entire team",
      "Available to only 3 accounts per quarter",
    ],
    guarantee: "Performance-tracked install with written delivery checklist",
  },
  dfy_plan: {
    eyebrow: "3-MONTH PAYMENT PLAN",
    name: "DFY Evergreen — Payment Plan",
    italic: "Installed",
    priceLabel: "× 3 monthly",
    features: [
      "Same complete DFY installation as the one-time plan",
      "Split into 3 monthly payments of $1,999 (auto-ends after 3)",
      "Work starts the moment the first payment clears",
      "Same VA training, same ops, same delivery timeline",
    ],
    guarantee: "Auto-cancels after 3 payments. No surprise fourth charge.",
  },
  cohort_plan: {
    eyebrow: "3-MONTH PAYMENT PLAN",
    name: "Evergreen Cohort — Payment Plan",
    italic: "Cohort",
    priceLabel: "× 3 monthly",
    features: [
      "Full 6-month Cohort access — every call, every replay, every perk",
      "Split into 3 monthly payments of $799 (auto-ends after 3)",
      "Same WhatsApp access, same 1:1s, same group calls",
      "Start with the next live session — no waiting",
    ],
    guarantee: "Auto-cancels after 3 payments. No surprise fourth charge.",
  },
};

export function summaryFor(tierId) {
  return CHECKOUT_SUMMARY[tierId] || null;
}
